import { render, staticRenderFns } from "./detailInfo.vue?vue&type=template&id=318795e6&scoped=true"
import script from "./detailInfo.vue?vue&type=script&lang=js"
export * from "./detailInfo.vue?vue&type=script&lang=js"
import style0 from "./detailInfo.vue?vue&type=style&index=0&id=318795e6&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "318795e6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/qhygcg-web-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('318795e6')) {
      api.createRecord('318795e6', component.options)
    } else {
      api.reload('318795e6', component.options)
    }
    module.hot.accept("./detailInfo.vue?vue&type=template&id=318795e6&scoped=true", function () {
      api.rerender('318795e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/projectInfo/components/detailInfo.vue"
export default component.exports